import { useEffect, useState } from 'react';
import logo from './agroai.jpg';
import './aiv1.scss';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import {toast, Toaster} from 'react-hot-toast'
import io from 'socket.io-client';

const socket = io('https://agroaiv1-demo-backend.onrender.com', {
    transports: ['websocket', 'polling'],
    withCredentials: true
  });

export const AIv1 = () => {

    const [input, setInput] = useState('');
    const [message, setMessage] = useState('');
    const navigate = useNavigate()

    useEffect(() => {
        socket.on("receive_message", (data) => {
            console.log(data)
            setMessage((prevState) => [...prevState, { role: "bot", message: data }])
        })
    },[])

    const handleSubmit = (e) => {
        e.preventDefault();
        setMessage((prevState) => [...prevState, { role: "user", message: input }])
        socket.emit("send_message", input);
        setInput('');
    }

    const navInfo = () => {
        navigate(`/info`)
    }

    const logout = () => {
        toast("Coming In The Full Update!")
    }

    return (
        <div className="aiv1-container">
            <div className="header-container">
                <div className='left-container'>
                <img src={logo} alt='logo'/>
                {/* <h3>Welcome.</h3> */}
                </div>
                <div className='right-container'>
                <span className='material-symbols-outlined info' onClick={navInfo}>info</span>
                <span className='material-symbols-outlined' onClick={logout}>logout</span>
                </div>
            </div>
            <div className='content-container'>
                <div className='chatbox-container'>
                    <div className='messages-container'>
                        {Array.isArray(message) ? message.map((item, index) => {
                            return (
                                <div key={index} className={item.role === "bot" ? "response-message" : "response-message other"}>
                                    <p>{item.message}</p>
                                </div>
                            )
                        }): null}
                    </div>
                    <div className='textbox-container'>
                        <input type='text' value={input} onChange={(e) => {setInput(e.target.value)}} placeholder='Enter message...'/>
                        <button onClick={handleSubmit}><span className='material-symbols-outlined' >send</span></button>
                    </div>
                </div>
            </div>
            <Toaster />
        </div>
    );
}